import Vue from 'vue'
import Vuex from 'vuex'
import shared from './modules/shared'
import notifications from './modules/notifications'
import atividades from './modules/atividades'
import projetos from './modules/projetos'
import situacoes from './modules/situacoes'
import colaboradores from './modules/colaboradores'
import tiposAtividade from './modules/tiposAtividade'
import prioridades from './modules/prioridades'
import tags from './modules/tags'
import usuarios from './modules/usuarios'
import clientes from './modules/clientes'
import tiposOcorrencia from './modules/tiposOcorrencia'
import notificacoes from './modules/notificacoes'
import tiposProjeto from './modules/tiposProjeto'
import atividadesVinculos from './modules/atividadesVinculos'
import sqls from './modules/sqls'
import layoutsSql from './modules/layoutssql'
import recursosSistema from './modules/recursosSistema'
import bairros from './modules/bairros'
import cidades from './modules/cidades'
import tiposSituacao from './modules/tiposSituacao'
import tiposColaborador from './modules/tiposColaborador'
import perfis from './modules/perfis'
import equipes from './modules/equipes'
import workflows from './modules/workflows'
import modelosAtividade from './modules/modelosAtividade'
import modelosOcorrencia from './modules/modelosOcorrencia'
import projetosVinculos from './modules/projetosVinculos'
import motivos from './modules/motivos'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    shared,
    notifications,
    atividades,
    projetos,
    situacoes,
    colaboradores,
    tiposAtividade,
    prioridades,
    tags,
    usuarios,
    clientes,
    tiposOcorrencia,
    notificacoes,
    tiposProjeto,
    atividadesVinculos,
    sqls,
    layoutsSql,
    recursosSistema,
    bairros,
    cidades,
    tiposSituacao,
    tiposColaborador,
    perfis,
    equipes,
    workflows,
    modelosAtividade,
    modelosOcorrencia,
    projetosVinculos,
    motivos
  }
})
